/* eslint-disable */
// @ts-nocheck
import { IVerticalBlockItem } from '../../../types'
import { dfpUtils } from '../../Player/Helpers'
import { translations } from '../../Player/Kaltura/translations'
import { IPlayerConfig } from '../../Player/Models/PlayerModels'
import { clientConfig, isDesktop } from '../../../client'
import { bitrateConfig } from '../../Player/Helpers/kaluraConfig'

declare global {
  interface Screen {
    mozLockOrientation?: (orientation: string) => boolean
    msLockOrientation?: (orientation: string) => boolean
    webkitLockOrientation?: (orientation: string) => boolean
    mozUnlockOrientation?: () => void
    msUnlockOrientation?: () => void
    webkitUnlockOrientation?: () => void
  }
}

/**
 * add targetId: playerId, to each video
 */
export const kalturaConfig = {
  targetId: '',
  provider: { partnerId: '2748741', uiConfId: '48907342' },
  playback: {
    autoplay: 'inview',
    loop: true,
    allowMutedAutoPlay: true,
    preload: 'auto',
    inBrowserFullscreen: true,
    screenLockOrientionMode: 'potrait',
    pictureInPicture: false,
    playInline: true,
  },
  cast: { receiverApplicationId: 'CF3B07A1' },
  advertising: {},
  ui: {
    components: {},
    locale: 'he',
    hoverTimeout: 0,
    translations: translations,
    uiComponents: [
      {
        label: '',
        presets: ['Playback'],
        container: '',
        beforeComponent: '',
        afterComponent: '',
        replaceComponent: '',
      },
    ],
  },
  components: {
    fullscreen: {
      disableDoubleClick: true,
    },
  },
  // dimensions: {
  //   ratio: '9:16',
  // },
}

/**
 * exit fullscreen page on mobile
 * and unlock screen orientation
 */
export const exitFullscreen = (document: Document) => {
  if (document.fullscreenElement) {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
    }
  }
  try {
    if (window.screen.orientation) {
      window.screen.orientation.unlock()
    } else if (window.screen.mozUnlockOrientation) {
      window.screen.mozUnlockOrientation()
    } else if (window.screen.msUnlockOrientation) {
      window.screen.msUnlockOrientation()
    } else if (window.screen.webkitUnlockOrientation) {
      window.screen.webkitUnlockOrientation()
    }
  } catch (error) {
    console.log('Orientation unlock not supported')
  }
}

/**
 * Custom seekbar component
 * @param kalturaPlayer
 * @returns Custom seekbar component
 */
export const customSeekbar = (kalturaPlayer: any) => {
  const { h, Utils } = KalturaPlayer.ui
  const { Component } = KalturaPlayer.ui.preact
  const withPlayer = KalturaPlayer.ui.components.withPlayer

  class CustomSeekbar extends Component {
    constructor(props: any) {
      super(props)
      this.state = {
        currentTime: props.player.currentTime || 0,
        duration: props.player.duration || 0,
      }
    }

    componentDidMount() {
      // Use Kaltura Player's event system
      this._timeUpdateListener = this.props.player.addEventListener(
        this.props.player.Event.TIME_UPDATE,
        () => {
          this.setState({ currentTime: this.props.player.currentTime })
          this.setState({ duration: this.props.player.duration })
        }
      )
    }

    componentWillUnmount() {
      // Cleanup the event listener
      if (this._timeUpdateListener) {
        this.props.player.removeEventListener(this._timeUpdateListener)
      }
    }

    formatTime(seconds: number) {
      return Utils.toHHMMSS(seconds)
    }
    render(props: any) {
      const { player } = this.props
      const { currentTime, duration } = this.state

      return h(
        'div',
        { className: 'custom-seekbar' },
        h(
          'div',
          { className: 'time' },
          this.formatTime(isNaN(duration) ? 0 : duration)
        ),
        h('div', { className: 'time' }, this.formatTime(currentTime))
      )
    }
  }

  return withPlayer(CustomSeekbar)
}

/**
 * Interleave ad slots after every `interval` videos (same cadence as before).
 * Ad slots carry no VAST data; ReelsAdVastPlayer fetches when mounted.
 */
export const buildReelSlides = (
  videos: IVerticalBlockItem[],
  interval: number,
  round = 0
): IReelSlide[] => {
  const slides: IReelSlide[] = []
  for (let i = 0; i < videos.length; i++) {
    slides.push({ type: 'video', key: `video-${round}-${i}`, item: videos[i] })
    if ((i + 1) % interval === 0 && i + 1 !== videos.length) {
      slides.push({ type: 'ad', key: `ad-${round}-${i}` })
    }
  }
  return slides
}

export const storyTitleComponent = (
  kalturaPlayer: any,
  title: string,
  ep?: number
) => {
  const { h } = KalturaPlayer.ui
  const { Component } = KalturaPlayer.ui.preact

  return class StoryTitle extends Component {
    render() {
      const story = []
      if (ep && ep > 0) {
        story.push(h('div', { className: 'story-tag' }, 'פרק ' + ep))
      }
      story.push(h('div', { className: 'story-title' }, title))
      return h('div', { className: 'story-overlay-preact' }, story)
    }
  }
}

/**
 * Preload kaltura video
 *
 * this function will work only when targetId is already set
 * @param index number
 * @param kalturaId string
 * @returns
 */
export const preloadKaltura = (index, kalturaId): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (window.KalturaPlayer) {
      if (!(`vertical-player-${index}` in window.KalturaPlayer.getPlayers())) {
        const kp = window.KalturaPlayer.setup({
          ...kalturaConfig,
          targetId: `vertical-player-${index}`,
        })
        try {
          kp.ready().then(() => {
            kp.loadMedia({ entryId: kalturaId }).then(() => {
              resolve(true)
            })
          })
        } catch (e) {
          reject(e)
        }
      }
    }
  })
}

export const verticalUiComponentSeekBar = () => {
  return {
    presets: ['Playback'],
    label: 'customSeekbar',
    area: 'BottomBar',
    get: customSeekbar(window.KalturaPlayer),
  }
}
const storyShareComponent = (url: string, title: string) => {
  const { h } = KalturaPlayer.ui
  const { Component } = KalturaPlayer.ui.preact

  return class StoryShare extends Component {
    handleShare(e) {
      e.preventDefault()
      e.stopPropagation()
      if (!isDesktop() && navigator.share) {
        navigator
          .share({
            title,
            url,
          })
          .catch(err => {
            console.warn('Share cancelled or failed:', err)
          })
      } else {
        navigator.clipboard
          .writeText(url)
          .then(() => {
            alert('הקישור הועתק בהצלחה!')
          })
          .catch(() => {
            console.warn('העתקת הקישור נכשלה')
          })
      }
    }

    render() {
      return h(
        'div',
        {
          className: 'story-share',
          onClick: e => this.handleShare(e),
          style: { cursor: 'pointer' },
        },
        h(
          'svg',
          {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg',
          },
          h('path', {
            d: 'M23 12L14.2 3V7.5C9.80001 7.5 1.00001 10.2 1.00001 21C1.00001 19.4996 3.64001 16.5 14.2 16.5V21L23 12Z',
            stroke: 'white',
            strokeWidth: '1.5',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          })
        )
      )
    }
  }
}
const storyMuteComponent = () => {
  const { h } = KalturaPlayer.ui
  const { Component } = KalturaPlayer.ui.preact
  const withPlayer = KalturaPlayer.ui.components.withPlayer

  class StoryMute extends Component {
    constructor(props) {
      super(props)
      this.state = { muted: window.__verticalPlayerMuted ?? false }
      this._globalMuteListener = null
    }

    componentDidMount() {
      this._globalMuteListener = (e: CustomEvent) => {
        this.setState({ muted: e.detail.muted })
      }
      window.addEventListener(
        'verticalPlayerMuteChange',
        this._globalMuteListener
      )
    }

    componentWillUnmount() {
      window.removeEventListener(
        'verticalPlayerMuteChange',
        this._globalMuteListener
      )
    }

    render(props) {
      const { player } = props

      const handleClick = e => {
        e.stopPropagation()
        e.preventDefault()
        const newMuted = !player.muted
        player.muted = newMuted
        window.__verticalPlayerMuted = newMuted
        this.setState({ muted: newMuted })
        window.dispatchEvent(
          new CustomEvent('verticalPlayerMuteChange', {
            detail: { muted: newMuted },
          })
        )
      }

      if (player && player.muted !== this.state.muted) {
        player.muted = this.state.muted
      }

      const muted = this.state.muted

      const UnmuteIcon = () =>
        h(
          'svg',
          {
            id: 'Layer_1',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 24 22',
            fill: 'none',
          },
          h('path', {
            fill: 'white',
            d: 'M15.9,16.3c-.2,0-.3,0-.4-.1-.1,0-.2-.2-.3-.4,0-.2,0-.3,0-.5,0-.2.2-.3.3-.4.7-.4,1.2-1,1.6-1.7.4-.7.6-1.5.6-2.3,0-.8-.2-1.6-.6-2.3s-1-1.3-1.7-1.6c0,0-.2-.1-.2-.2,0,0-.1-.2-.1-.3,0,0,0-.2,0-.3,0,0,0-.2,0-.3,0,0,.1-.2.2-.2,0,0,.2-.1.3-.1,0,0,.2,0,.3,0,0,0,.2,0,.3.1.9.5,1.7,1.3,2.2,2.2.5.9.8,1.9.8,3,0,1-.2,2.1-.7,3-.5.9-1.2,1.7-2.1,2.3-.1,0-.2.1-.4.1Z',
          }),
          h('path', {
            fill: 'white',
            d: 'M17.6,20.7c-.2,0-.3,0-.5-.2-.1-.1-.2-.2-.3-.4s0-.3,0-.5c0-.2.2-.3.3-.3,1.6-.8,2.9-2,3.8-3.4.9-1.5,1.4-3.2,1.4-4.9,0-1.7-.5-3.4-1.4-4.9-.9-1.5-2.3-2.6-3.8-3.4,0,0-.2,0-.2-.2,0,0-.1-.2-.2-.3,0,0,0-.2,0-.3,0,0,0-.2,0-.3,0,0,.1-.2.2-.2,0,0,.2-.1.3-.1,0,0,.2,0,.3,0,0,0,.2,0,.3,0,1.8.9,3.4,2.2,4.4,3.9,1.1,1.7,1.7,3.7,1.7,5.7,0,2-.5,4-1.6,5.7-1.1,1.7-2.6,3.1-4.4,4-.1,0-.2,0-.4,0Z',
          }),
          h('path', {
            fill: 'white',
            d: 'M11.9,21.4c-.2,0-.4,0-.6-.1-.2,0-.3-.2-.5-.3l-5.5-5.5H1.6c-.4,0-.8-.2-1-.4s-.4-.7-.4-1v-5.9c0-.4.2-.8.4-1,.3-.3.7-.4,1-.4h3.9L10.9,1.1c.2-.2.5-.4.8-.4.3,0,.6,0,.9,0,.3.1.5.3.7.5.2.2.3.5.3.8v17.8c0,.3,0,.6-.3.8-.2.2-.4.4-.7.5-.2,0-.4.1-.6.2ZM1.6,8v5.9h4.1c0,0,.2,0,.3,0,0,0,.2,0,.2.2l5.7,5.7V2.1l-5.7,5.7c0,0-.2.1-.2.2,0,0-.2,0-.3,0H1.6Z',
          })
        )

      const MuteIcon = () =>
        h(
          'svg',
          {
            id: 'Layer_1',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 27 27',
            fill: 'none',
          },
          h('path', {
            fill: 'white',
            d: 'M1.4,3.6l4.7,4.7H1.7c-.4,0-.9.2-1.2.5-.3.3-.5.7-.5,1.2v6.7c0,.4.2.9.5,1.2.3.3.7.5,1.2.5h4.3l6.2,6.3c.2.2.4.3.6.3.2,0,.4.1.7.1.2,0,.4,0,.6-.1.3-.1.6-.3.8-.6.2-.3.3-.6.3-.9v-6.1l5,5c-.2.1-.4.2-.6.4-.2.1-.4.3-.4.5,0,.2,0,.4,0,.6.1.2.3.4.5.4.2,0,.4,0,.6,0,.4-.2.7-.4,1.1-.6l1.9,1.9,1.2-1.2L2.5,2.4l-1.2,1.2ZM13.5,23.4l-6.5-6.5c-.2-.1-.4-.2-.6-.2H1.7v-6.7h4.7c.1,0,.2,0,.3,0,.1,0,.2-.1.3-.2l.2-.2,6.2,6.2v7.7Z',
          }),
          h('path', {
            fill: 'white',
            d: 'M19.3,3.8c1.5.7,2.8,1.7,3.8,3s1.7,2.8,2,4.3c.3,1.6.3,3.2-.1,4.8-.4,1.6-1.2,3-2.2,4.2l1.2,1.2c1.3-1.4,2.2-3.1,2.7-4.9.5-1.8.5-3.7.2-5.6-.4-1.9-1.2-3.6-2.4-5.1-1.2-1.5-2.7-2.7-4.4-3.5-.1,0-.2,0-.3,0-.1,0-.2,0-.3,0-.1,0-.2,0-.3.2,0,0-.2.2-.2.3,0,.1,0,.2,0,.3,0,.1,0,.2,0,.3,0,.1,0,.2.2.3s.2.1.3.2h0Z',
          }),
          h('path', {
            fill: 'white',
            d: 'M17.4,8.8c.8.5,1.5,1.1,1.9,1.9.5.8.7,1.7.7,2.6,0,1.1-.4,2.2-1,3.1l1.2,1.2c1-1.2,1.5-2.7,1.5-4.3,0-1.2-.3-2.4-.9-3.5-.6-1-1.5-1.9-2.5-2.5,0,0-.2-.1-.3-.1-.1,0-.2,0-.3,0-.1,0-.2,0-.3.1,0,0-.2.2-.2.3,0,0,0,.2-.1.3,0,.1,0,.2,0,.3,0,.1,0,.2.2.3,0,0,.2.2.3.2h0Z',
          }),
          h('path', {
            fill: 'white',
            d: 'M13.5,3.2v7.7l1.7,1.7V3.2c0-.3,0-.7-.3-.9-.2-.3-.4-.5-.8-.6-.3-.1-.6-.2-1,0-.3,0-.6.2-.9.5l-3.9,3.9,1.2,1.2,3.9-3.9Z',
          })
        )

      return h(
        'div',
        {
          className: 'story-mute',
          onClick: handleClick,
          style: { cursor: 'pointer' },
        },
        muted ? h(MuteIcon, null) : h(UnmuteIcon, null)
      )
    }
  }

  return withPlayer(StoryMute)
}

export const verticalUiComponentMute = (
  area: 'TopBarRightControls' | 'TopBarLeftControls'
) => {
  return {
    presets: ['Playback'],
    label: 'customMute',
    area,
    get: storyMuteComponent(),
  }
}

export const verticalUiComponentsRemove = () => {
  const components = [
    'Volume',
    'Settings',
    'Fullscreen',
    'Rewind',
    'Forward',
    'TimeDisplayPlaybackContainer',
    'PictureInPicture',
  ]
  return [
    verticalUiComponentSeekBar(),
    ...components.map(cName => {
      return {
        presets: ['Playback'],
        area: 'BottomBarRightControls',
        replaceComponent: cName,
        get: 'remove',
      }
    }),
  ]
}

/**
 * Seconds of video kept ahead by hls.js (desktop and Android; iOS plays HLS
 * natively). The default (30, and the whole clip on fast links) made the clip
 * loaded ahead download in full even when the user swipes after a second.
 */
// Kaltura's clips start with 2 s segments (2, 2, 2, 4, then ~10): 6 s is the
// first three, so a clip loaded ahead costs a few hundred KB, not ~20 s of video
const VERTICAL_BUFFER_AHEAD_S = 6
const VERTICAL_BUFFER_AHEAD_MAX_S = 10

/**
 * Quality by the player's real size on screen (its size times the screen's
 * pixel ratio): 1080p full screen on a sharp phone, less in the desktop box.
 * The shared bitrateConfig caps a landscape height instead (520 here): every
 * vertical track is taller than that, so Kaltura dropped the cap and played
 * 1080p (2.3-4.4 Mbps) everywhere, the desktop box included.
 */
const verticalAbr = () => {
  const abr = bitrateConfig('720')
  return {
    ...abr,
    capLevelToPlayerSize: true,
    restrictions: {
      ...abr.restrictions,
      maxHeight: Infinity,
      maxBitrate: Infinity,
    },
  }
}

export const getVerticalPlayerConfig = ({
  playerId,
  poster,
  loop = true,
  allowMutedAutoPlay = true,
  adTagUrl,
  muted = false,
  autoplay = 'inview',
}: {
  playerId: string | number
  poster: string
  /** ignored: the quality follows the player's size, see verticalAbr */
  bitrate?: string
  loop?: boolean
  allowMutedAutoPlay?: boolean
  /** start state of the sound; never unmute later from code (iOS pauses the video) */
  muted?: boolean
  /** false for a look-ahead player: Kaltura preloads only when autoplay is off */
  autoplay?: 'inview' | boolean
  /**
   * RESH13-1138 - when set, IMA plays this VAST as a pre-roll inside the player.
   * Reels leave it empty: there the ads are separate slides in the feed.
   */
  adTagUrl?: string
}) => {
  return {
    abr: verticalAbr(),
    targetId: playerId,
    provider: { partnerId: '2748741', uiConfId: '48907342' },
    // ignore Kaltura's remembered mute/volume, like the main and OTT players
    disableUserCache: true,
    playback: {
      autoplay,
      muted,
      loop: loop,
      allowMutedAutoPlay: allowMutedAutoPlay,
      preload: 'auto',
      inBrowserFullscreen: true,
      screenLockOrientionMode: 'portrait',
      pictureInPicture: false,
      options: {
        html5: {
          hls: {
            maxBufferLength: VERTICAL_BUFFER_AHEAD_S,
            maxMaxBufferLength: VERTICAL_BUFFER_AHEAD_MAX_S,
          },
        },
      },
    },
    plugins: {
      ima: adTagUrl
        ? {
            disable: false,
            adTagUrl,
          }
        : {
            disable: true,
          },
      imadai: {
        disable: true,
      },
      share: {
        disable: true,
      },
      timeline: {
        disable: true,
      },
    },
    cast: { receiverApplicationId: 'CF3B07A1' },
    advertising: {},
    ui: {
      components: {
        fullscreen: {
          disableDoubleClick: true,
        },
        // no seek-bar preview here, so no 0.4-0.65 MB thumbnail sprite per clip
        seekbar: {
          thumbsSprite: '',
        },
      },
      locale: 'he',
      hoverTimeout: 0,
      translations: translations,
      uiComponents: verticalUiComponentsRemove(),
    },
    components: {
      fullscreen: {
        disableDoubleClick: true,
      },
    },
    settings: {
      showQualityMenu: false,
      showSpeedMenu: false,
      showAudioMenu: false,
    },
    sources: { poster },
  } as IPlayerConfig
}

export const verticalUiComponentTitle = ({
  title,
  ep,
}: {
  title: string
  ep: number
}) => {
  return {
    presets: ['Playback'],
    label: 'customTitle',
    area: 'BottomBar',
    get: storyTitleComponent(window.KalturaPlayer, title, ep),
  }
}

export const verticalUiComponentShare = ({
  link,
  title,
  area,
}: {
  link: string
  title: string
  area: 'TopBarRightControls' | 'TopBarLeftControls' | 'BottomBarLeftControls'
}) => {
  return {
    presets: ['Playback'],
    label: 'customShare',
    area: area,
    get: storyShareComponent(link, title),
  }
}

/**
 * Custom Title component
 * @param kalturaPlayer
 */
export const testComponent = (kalturaPlayer: any) => {
  const h = KalturaPlayer.ui.h
  const { Component } = KalturaPlayer.ui.preact

  return class DumpComponent extends Component {
    render(props) {
      return h(
        'div',
        { className: 'dumb-component' },
        h('h1', null, props.title),
        h('a', { href: props.link, target: '_blank' }, '👎')
      )
    }
  }
}
/**
 * Insert ads after every 3rd video
 */
export const insertAds = async (arr: IVerticalBlockItem[]) => {
  const result: IVerticalBlockItem[] = []
  for (let i = 0; i < arr.length; i++) {
    result.push(arr[i])
    if ((i + 1) % 3 === 0 && i + 1 !== arr.length) {
      const vastData = await dfpUtils.parseVast({
        pageViewedInDay: pageViewInDayCount,
        environment: clientConfig.adTargetEnv || 'prod',
        ComponentType: isMiniSeries ? 'mini_series' : 'mintly',
        componentId: gridId,
        assetId: '',
        referenceId: '',
      }) // Fetch VAST data
      if (!vastData.hasAds || vastData.error) {
        console.warn('Error fetching ads', vastData.error)
      } else {
        if (vastData.data) {
          result.push({
            link: '',
            video: {
              duration: 0,
              poster: '',
              kalturaId: '',
              name: '',
            },
            ads: {
              url: vastData.data.url,
              duration: vastData.data.duration,
              video: vastData.data.video,
              vastAd: vastData.data.vastAd,
              vastCreative: vastData.data.vastCreative,
            },
            title: 'Advertisement',
            poster: '',
          })
        }
      }
    }
  }
  return result
}
/**
 * Find last visible slide and add class to it
 */
export const attachClassToLastSlide = (
  swiperElem: string | HTMLElement
): void => {
  const swiperElem2 =
    typeof swiperElem === 'string'
      ? document.querySelector(swiperElem)
      : swiperElem

  if (!swiperElem2) {
    return
  }

  const slidesVisible = swiperElem2.querySelectorAll<HTMLElement>(
    '.swiper-slide-visible'
  )
  const lengthVisibleSlide = slidesVisible.length

  slidesVisible.forEach(slide => slide.classList.remove('last-slide'))

  if (lengthVisibleSlide > 0) {
    slidesVisible[lengthVisibleSlide - 1].classList.add('last-slide')
  }
}

/**
 * enter fullscreen page on mobile
 * and lock screen orientation to portrait
 */
export const enterFullscreen = (document: Document) => {
  try {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen()
    } else if (document.documentElement.webkitRequestFullscreen) {
      document.documentElement.webkitRequestFullscreen()
    } else if (document.documentElement.msRequestFullscreen) {
      document.documentElement.msRequestFullscreen()
    }

    // Handle screen orientation
    if (window.screen.orientation) {
      // Standard API (Chrome, Firefox, etc.)
      window.screen.orientation.lock('portrait')
    } else if (window.screen.mozLockOrientation) {
      // Firefox (older versions)
      window.screen.mozLockOrientation('portrait')
    } else if (window.screen.msLockOrientation) {
      // IE/Edge
      window.screen.msLockOrientation('portrait')
    } else if (window.screen.webkitLockOrientation) {
      // WebKit (Safari)
      window.screen.webkitLockOrientation('portrait')
    }
  } catch (error) {
    console.log('Fullscreen or orientation lock not supported on this device')
  }
}
